import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { LoggedInUserInfo } from '../models/login';
import { RootScopeService } from './root-scope.service';
import * as Constants from '../models/Constants';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  public loginDeatils: LoggedInUserInfo = new LoggedInUserInfo();
  enableDebugLogs: boolean = true;
  enableInfoLogs :boolean = true;
  enableErrorLogs :boolean = true;
  constructor(private logger: NGXLogger,
    public rootScope: RootScopeService
  ) {
    this.rootScope.logSubject.subscribe(({ message, fileName, Type }) => {
      if (Type === Constants.DEBUG)
        this.debugLogs(message, fileName);
      else if (Type === Constants.INFO)
        this.infoLogs(message, fileName);
      else
        this.errorLogs(message, fileName);

    });

  }


  //level  TRACE = 0,DEBUG = 1,INFO = 2, LOG = 3, WARN = 4,ERROR = 5,FATAL = 6,OFF = 7
  
  trace(message) {
    this.genSysDetails();
    this.logger.trace(message, this.loginDeatils);
  }
 
  debug(message) {
    this.genSysDetails();
    this.logger.debug(message, this.loginDeatils);
  }

 
  info(message) {
    this.genSysDetails();
    this.logger.log(message, this.loginDeatils);
  }

  warn(message) {
    this.genSysDetails();
    this.logger.warn(message, this.loginDeatils);
  }

  error(message, server?) {
    this.genSysDetails();this.loginDeatils.message=message;
    this.loginDeatils.serverError = server ? true : false;
    this.logger.error(message, this.loginDeatils);
  }

  log(message) {
    this.genSysDetails();
    this.loginDeatils.message=message;
    this.logger.log(message, this.loginDeatils);
  }

  fatal(message) {
    this.genSysDetails();this.loginDeatils.message=message;
    this.logger.fatal(message, this.loginDeatils);
  }

  genSysDetails() {
    this.loginDeatils.sessionId=this.rootScope.sessionId;
    this.loginDeatils.userName = this.rootScope.name;
    this.loginDeatils.lanId = this.rootScope.lanId;
    //this.loginDeatils.token = this.rootScope.sessionId;
  }



  /************************** CCR1-6336**********************/
 
  errorLogs(message , fileName){
    const msg: any = 'ERROR ' + '| FILE NAME - ' + fileName + ' | MESSAGE - ' + message;
    if (sessionStorage.getItem('tba_port')&&this.rootScope.isLogEnabledUser?.includes(Constants.ERROR)) {
      this.sendLogIntoTBA(msg);
    }

    if(this.enableErrorLogs)
      this.dumpLogsToUIConsole(msg);
  }

  dumpLogsToUIConsole(data){
    console.log(data)
  }


  debugLogs(message , fileName){
    const msg: any = 'DEBUG ' +  '| FILE NAME - ' + fileName + ' | MESSAGE - ' + message;
    if (sessionStorage.getItem('tba_port')&&this.rootScope.isLogEnabledUser?.includes(Constants.DEBUG)) {
      this.sendLogIntoTBA(msg);
    }

    if(this.enableDebugLogs)
      this.dumpLogsToUIConsole(msg);
  
  }

  infoLogs(message , fileName){
    const msg: any = 'INFO ' + ' | FILE NAME - ' + fileName + ' | MESSAGE - ' + message;
    if (sessionStorage.getItem('tba_port')&&this.rootScope.isLogEnabledUser?.includes(Constants.INFO)) {
      this.sendLogIntoTBA(msg);
    }
    
    if(this.enableInfoLogs)
      this.dumpLogsToUIConsole(msg);
  }


  
  getTBALogsApiEndPt() {
    const port = sessionStorage.getItem('tba_port');
    const sessionId = sessionStorage.getItem('tba_sessionId');
    const url = 'https://localhost:' + port + '/log/' + sessionId + '/' + 'CarePortal';
    return url;
  }


  
  sendLogIntoTBA(data: any) {
    const url = this.getTBALogsApiEndPt();
  
    fetch(url, {
      method: 'POST',
      body: new Blob([data])
    })
      .then(response => response.json())
      .then(data => {
        console.log('Log array uploaded successfully:', data);
      })
      .catch(error => {
          
        console.error('Error uploading log array to TBA', error);
      });
  }
}
